import { RefreshCw, TriangleAlert } from 'lucide-react';
import { Button } from '../components/Button';
import { EmptyState } from '../components/EmptyState';

/** Last resort for an error while rendering a screen: a way out instead of a blank page. */
export function RouteErrorPage() {
  return (
    <div style={{ padding: 'var(--space-4)' }}>
      <EmptyState
        icon={TriangleAlert}
        title="Nie udało się otworzyć tego ekranu"
        action={
          <Button variant="primary" icon={<RefreshCw aria-hidden="true" />} onClick={() => window.location.reload()}>
            Odśwież
          </Button>
        }
      >
        Sprawdź połączenie z internetem i odśwież stronę. Jeśli aplikacja została właśnie zaktualizowana, odświeżenie
        wczyta nową wersję.
      </EmptyState>
    </div>
  );
}
